module.exports = __webpack_public_path__ + "img/Dredd_Action.2ac7c0ea.jpeg";